(ns frontend.test.breadcrumbs
  (:require [frontend.routing :as routing]
            [basic-components.breadcrumbs :as breadcrumbs]))

(def breadcrumbs
  [{:label     "Home"
    :active?   false
    :on-click! identity}
   {:label     "Registration"
    :active?   false
    :on-click! identity}
   {:label     "Personal information"
    :active?   true
    :on-click! identity}])

(defmethod routing/render-view :test/breadcrumbs [{:keys [route-params]}]
  (let []
    [:div.container.bg-white.scroll
     [:h1.title-h1.my-4 "Breadcrumbs"]
     [:h2.title-h2.mb-2 "Breadcrumbs"]
     [:span.mb-4 "A breadcrumb is used to show hierarchy between content"]
     [:h3.title-h3.mt-4.mb-2 "Divider"]
     [:span "A breadcrumb can contain a divider to show the relationship between sections, this can be formatted as an icon or text"]
     [breadcrumbs/view breadcrumbs]
     [:h3.title-h3.mt-4.mb-2 "Variations"]
     [:span "A breadcrumb can vary in size"]
     [breadcrumbs/view breadcrumbs "zap-breadcrumbs__item--xs-small"]
     [breadcrumbs/view breadcrumbs "zap-breadcrumbs__item--small"]
     [breadcrumbs/view breadcrumbs "zap-breadcrumbs__item--medium"]
     [breadcrumbs/view breadcrumbs "zap-breadcrumbs__item--big"]
     [breadcrumbs/view breadcrumbs "zap-breadcrumbs__item--large"]]))
